import { ReactNode } from "react";
import { Card, Space, Typography } from "antd";

const { Text, Title } = Typography;

export interface ResponsiveDataCardRow {
  label: ReactNode;
  value: ReactNode;
}

interface ResponsiveDataCardProps {
  title: ReactNode;
  subtitle?: ReactNode;
  tag?: ReactNode;
  rows: ResponsiveDataCardRow[];
  extra?: ReactNode;
  className?: string;
}

export const ResponsiveDataCard = ({
  className,
  extra,
  rows,
  subtitle,
  tag,
  title,
}: ResponsiveDataCardProps) => (
  <Card
    className={["responsive-data-card", className].filter(Boolean).join(" ")}
  >
    <Space direction="vertical" size={14} style={{ width: "100%" }}>
      <div className="responsive-data-card__header">
        <div>
          <Title level={5}>{title}</Title>
          {subtitle ? <Text type="secondary">{subtitle}</Text> : null}
        </div>
        {tag ? <div className="responsive-data-card__tag">{tag}</div> : null}
      </div>
      <div className="responsive-data-card__rows">
        {rows.map((row, index) => (
          <div
            className="responsive-data-card__row"
            key={`${String(row.label)}-${index.toString()}`}
          >
            <Text type="secondary">{row.label}</Text>
            <Text strong>{row.value}</Text>
          </div>
        ))}
      </div>
      {extra ? (
        <div className="responsive-data-card__extra">{extra}</div>
      ) : null}
    </Space>
  </Card>
);
